function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "186.907 24.321 125.43 127.624",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -156.269135, 0.253989)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(255, 255, 255)"
    },
    d: "M 345.865 130.019 C 341.877 128.325 343.563 122.363 343.366 118.358 C 343.27 116.398 348.006 106.099 354.311 94.691 L 386.012 111.267 C 391.286 112.681 391.628 112.339 395.626 110.046 L 412.925 98.497 C 413.861 97.302 414.56 97.576 414.675 95.655 C 414.847 92.798 415.225 87.484 414.466 85.98 C 413.88 84.597 412.767 85.022 411.59 85.717 C 407.348 88.228 399.475 94.357 395.611 95.831 C 392.778 96.912 388.912 95.073 388.961 95.111 L 362.397 80.968 C 368.27 71.667 374.331 63.601 378.68 60.975 L 433.086 25.739 C 449.256 18.924 468.138 34.442 468.606 45.389 C 468.277 45.221 468.388 77.426 467.801 78.208 C 467.577 78.508 464.736 89.204 461.199 91.746 C 451.099 99.006 430.422 114.26 411.976 126.909 C 410.27 128.079 408.583 129.226 406.926 130.343 C 404.684 131.854 402.494 133.308 400.384 134.686 C 396.375 137.304 392.651 139.644 389.38 141.564 C 383.569 144.976 371.621 145.596 370.049 145.569 C 365.623 145.927 345.426 130.055 345.865 130.019 Z M 367.201 136.428 C 367.029 137.76 367.517 138.245 368.642 138.615 C 369.859 138.76 370.703 137.897 370.898 136.947 C 371.092 135.998 370.803 134.781 369.509 134.539 C 368.379 134.328 367.373 135.092 367.201 136.428 Z M 346.983 124.42 C 346.811 125.751 347.299 126.237 348.424 126.606 C 349.641 126.751 350.485 125.888 350.68 124.939 C 350.874 123.989 350.585 122.772 349.291 122.531 C 348.161 122.319 347.156 123.083 346.983 124.42 Z M 460.102 52.272 L 420.315 80.432 C 419.109 81.159 418.872 81.528 418.872 82.937 L 418.923 91.256 C 418.931 92.618 420.324 93.039 421.503 92.358 L 461.019 63.953 C 462.317 63.122 462.196 62.369 462.197 60.828 L 462.16 53.837 C 462.166 52.58 460.126 52.258 460.102 52.272 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    cx: 264.408,
    cy: 155.737,
    rx: 6.779,
    ry: 4.761,
    transform: "matrix(0.82357, -0.567214, 0.567214, 0.82357, 99.560791, 151.159523)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    cx: 264.408,
    cy: 155.737,
    rx: 6.779,
    ry: 4.761,
    transform: "matrix(0.82357, -0.567214, 0.567214, 0.82357, 114.09993, 140.903221)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    cx: 264.408,
    cy: 155.737,
    rx: 6.779,
    ry: 4.761,
    transform: "matrix(0.82357, -0.567214, 0.567214, 0.82357, 128.64238, 130.706169)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    cx: 264.408,
    cy: 155.737,
    rx: 6.779,
    ry: 4.761,
    transform: "matrix(0.82357, -0.567214, 0.567214, 0.82357, 143.057251, 120.385605)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      strokeWidth: 2,
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 255, 255)"
    },
    x1: 384.405,
    y1: 151.691,
    x2: 465.824,
    y2: 93.461
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainIcon);
export default __webpack_public_path__ + "static/media/train_icon.58b0d821c19c9e68665c38eef5c01dd9.svg";
export { ForwardRef as ReactComponent };